/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = Disabled 1 = Log 2 = Block
 */
export type UploadScanningScannerMode = 0 | 1 | 2;

export const UploadScanningScannerMode = {
  Disabled: 0 as UploadScanningScannerMode,
  Log: 1 as UploadScanningScannerMode,
  Block: 2 as UploadScanningScannerMode,
};
